export default {
  user: {
    email: null,
    admin: false,
  },
};
